<template>
  <div class="wrapper">
    <div class="page page1">
      <div class="header">
        <span class="nb"></span>
        <div class="date">
          申請日：
          <span class="y">{{editedItem.applyDate.year}}</span>年
          <span class="m">{{editedItem.applyDate.month}}</span>月
          <span class="d">{{editedItem.applyDate.day}}</span>日
        </div>
      </div>
      <!--header-->
      <div class="area1">
        <div class="title">申請人</div>
        <table class="table1">
          <tr>
            <td width="177px">
              <span class="tdTit">
                姓名：
                <br />(公司名)
              </span>
              <div class="con1">
                <span>{{editedItem.customer.name}}</span>
              </div>
            </td>
            <td width="177px">
              <span class="tdTit">
                身分證字號：
                <br />(統編)
              </span>
              <div class="con2">{{editedItem.customer.memberId}}</div>
            </td>
            <td width="195px">
              <span class="tdTit">行動電話：</span>
              <div class="con3">{{editedItem.customer.cellphone}}</div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">學歷：</span>
              <div class="con4">
                <div class="checkDiv">
                  <span class="checkbox checkbox1">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                      <img v-if="editedItem.customer.educationLevel[1].value" :src="checkedImage"  />
                    </label>
                  </span>
                  碩士以上
                </div>
                <div class="checkDiv">
                  <span class="checkbox checkbox2">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                      <img v-if="editedItem.customer.educationLevel[2].value" :src="checkedImage"  />
                    </label>
                  </span>
                  大學
                </div>
                <div class="checkDiv">
                  <span class="checkbox checkbox3">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                      <img v-if="editedItem.customer.educationLevel[3].value" :src="checkedImage"  />
                    </label>
                  </span>
                  專科
                </div>
                <br />
                <div class="checkDiv">
                  <span class="checkbox checkbox4">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                      <img v-if="editedItem.customer.educationLevel[4].value" :src="checkedImage"  />
                    </label>
                  </span>
                  高中職&nbsp;&nbsp;&nbsp;
                </div>
                <div class="checkDiv">
                  <span class="checkbox checkbox5">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                      <img v-if="editedItem.customer.educationLevel[5].value" :src="checkedImage"  />
                    </label>
                  </span>
                  初中以下
                </div>
              </div>
            </td>
          </tr>
        </table>
        <table class="table2">
          <tr class="tr">
            <td width="177px">
              <span class="tdTit">任職公司：</span>
              <div class="con5">
                <span>{{editedItem.company.name}}</span>
              </div>
            </td>
            <td width="177px">
              <span class="tdTit">公司統編：</span>
              <div class="con6">{{editedItem.company.companyId}}</div>
            </td>
            <td width="195px">
              <span class="tdTit">職稱：</span>
              <div class="con7">
                <span>{{editedItem.company.title}}</span>
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">年資：</span>
              <span class="con8">
                {{editedItem.company.workYear}}
                <span>年</span>
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <span class="tdTit">公司地址：</span>
              <div class="con9">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div class="con10">
                <span>{{editedItem.company.address}}</span>
              </div>
            </td>
            <td>
              <span class="tdTit">公司電話：</span>
              <div class="con11">{{editedItem.company.phone}}</div>
              <span class="tdTit tdTit11">分機：</span>
              <div class="con12"></div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">月收入：NT</span>
              <span class="con13">
                {{editedItem.company.salary}}
                <span>萬元</span>
              </span>
            </td>
          </tr>
        </table>
        <table class="table3">
          <tr class="tr">
            <td width="450px">
              <span class="tdTit">戶籍地址：</span>
              <div class="con14">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div class="con15">
                <span>{{editedItem.customer.home.residenceAddress}}</span>
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">戶籍電話：</span>
              <div class="con16">{{editedItem.customer.phone}}</div>
              <div class="con17">
                <div class="checkDiv">
                  <span class="checkbox checkbox6">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                      <img v-if="editedItem.customer.home.liveLevel[0].value" :src="checkedImage"  />
                    </label>
                  </span>
                  自有
                </div>
                <div class="checkDiv">
                  <span class="checkbox checkbox7">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                      <img v-if="editedItem.customer.home.liveLevel[1].value" :src="checkedImage"  />
                    </label>
                  </span>
                  家人
                  <span class="s1"></span>
                </div>
                <br />
                <div class="checkDiv">
                  <span class="checkbox checkbox8">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                      <img v-if="editedItem.customer.home.liveLevel[3].value" :src="checkedImage" />
                    </label>
                  </span>
                  租賃，居住
                  <span class="s3">年</span>
                  <span class="s2">{{editedItem.customer.home.liveYear}}</span>
                </div>
              </div>
            </td>
          </tr>

          <tr class="trB">
            <td>
              <span class="tdTit">通訊地址：</span>
              <div class="con18">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div class="con19">
                <span>{{editedItem.customer.home.homeAddress1}}</span>
              </div>
              <div class="con20">
                <div class="checkDiv">
                  <span class="checkbox checkbox9">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                      <img v-if="editedItem.customer.home.homeType1[0].value" :src="checkedImage"  />
                    </label>
                  </span>
                  同戶籍
                </div>
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">通訊電話：</span>
              <div class="con21">{{editedItem.customer.homePhone}}</div>
              <div class="con22">
                <div class="checkDiv">
                  <span class="checkbox checkbox10">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                      <img v-if="editedItem.customer.home.liveLevel2[0].value" :src="checkedImage"  />
                    </label>
                  </span>
                  自有
                </div>
                <div class="checkDiv">
                  <span class="checkbox checkbox11">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                      <img v-if="editedItem.customer.home.liveLevel2[1].value" :src="checkedImage"  />
                    </label>
                  </span>
                  家人
                  <span class="s1"></span>
                </div>
                <br />
                <div class="checkDiv">
                  <span class="checkbox checkbox12">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                      <img v-if="editedItem.customer.home.liveLevel2[3].value" :src="checkedImage"  />
                    </label>
                  </span>
                  租賃，居住
                  <span class="s3">年</span>
                  <span class="s2">{{editedItem.customer.home.liveYear2}}</span>
                </div>
              </div>
            </td>
          </tr>
          
          <tr>
            <td>
              <span class="tdTit">繳款方式：</span>
              <div class="con23">
                <div class="checkDiv">
                  <span class="checkbox checkbox13">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                      <img v-if="editedItem.paymentInfo.debitNote.isDebitNote" :src="checkedImage"  />
                    </label>
                  </span>
                  繳款單(寄送地址：
                </div>
                <div class="checkDiv">
                  <span class="checkbox checkbox14">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                      <img v-if="editedItem.paymentInfo.debitNote.isRegistration" :src="checkedImage" />
                    </label>
                  </span>
                  戶籍地&nbsp;&nbsp;
                </div>
                <div class="checkDiv">
                  <span class="checkbox checkbox15">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                      <img v-if="editedItem.paymentInfo.debitNote.isMailingAddress" :src="checkedImage"  />
                    </label>
                  </span>
                  通訊地&nbsp;&nbsp;&nbsp;
                </div>
                <div class="checkDiv">
                  <span class="checkbox checkbox16">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                      <img v-if="editedItem.paymentInfo.debitNote.isCompanyAddress" :src="checkedImage"  />
                    </label>
                  </span>
                  公司地)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
                <div class="checkDiv">
                  <span class="checkbox checkbox17">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                      <img v-if="editedItem.paymentInfo.isAutoBillPay" :src="checkedImage"  />
                    </label>
                  </span>
                  ACH&nbsp;自動扣繳
                </div>
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">E-mail：</span>
              <div class="con24">{{editedItem.customer.email}}</div>
            </td>
          </tr>
        </table>
        <div class="clear"></div>
      </div>
      <!--area1-->
      <div class="area2">
        <div class="title">聯絡人一</div>
        <table class="table4">
          <tr class="tr">
            <td width="177px">
              <span class="tdTit">姓名：</span>
              <div class="con25">{{editedItem.firstContact.name}}</div>
            </td>
            <td width="177px">
              <span class="tdTit">關係：</span>
              <div class="con26">{{editedItem.firstContact.type}}</div>
            </td>
            <td width="195px">
              <span class="tdTit">室話：</span>
              <div class="con27">{{editedItem.firstContact.homePhone}}</div>
              <span class="tdTit tdTit27">分機：</span>
              <div class="con28"></div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">行動：</span>
              <div class="con29">{{editedItem.firstContact.cellphone}}</div>
            </td>
          </tr>
          <tr>
            <td colspan="4" class="tdEnd">
              <span class="tdTit">聯絡地址：</span>
              <div class="con30">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div class="con31">
                <span></span>
              </div>
            </td>
          </tr>
        </table>
        <div class="clear"></div>
      </div>
      <!--area2-->
      <div class="area3">
        <div class="title">聯絡人二</div>
        <table class="table5">
          <tr class="tr">
            <td width="177px">
              <span class="tdTit">姓名：</span>
              <div class="con32">{{editedItem.secondContact.name}}</div>
            </td>
            <td width="177px">
              <span class="tdTit">關係：</span>
              <div class="con33">{{editedItem.secondContact.type}}</div>
            </td>
            <td width="195px">
              <span class="tdTit">室話：</span>
              <div class="con34">{{editedItem.secondContact.homePhone}}</div>
              <span class="tdTit tdTit34">分機：</span>
              <div class="con35"></div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">行動：</span>
              <div class="con36">{{editedItem.secondContact.cellphone}}</div>
            </td>
          </tr>
          <tr>
            <td colspan="4" class="tdEnd">
              <span class="tdTit">聯絡地址：</span>
              <div class="con37">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div class="con38">
                <span></span>
              </div>
            </td>
          </tr>
        </table>
        <div class="clear"></div>
      </div>
      <!--area2-->
      <div class="area4">
        <div class="title">保證人</div>
        <table class="table6">
          <tr>
            <td width="177px">
              <span class="tdTit">姓名：</span>
              <div class="con39">{{editedItem.jointGuarantor.name}}</div>
            </td>
            <td width="177px">
              <span class="tdTit">身分證字號：</span>
              <div class="con40">{{editedItem.jointGuarantor.memberId}}</div>
            </td>
            <td width="195px">
              <span class="tdTit">行動電話：</span>
              <div class="con41">{{editedItem.jointGuarantor.cellphone}}</div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">關係：</span>
              <div class="con42">{{editedItem.jointGuarantor.type}}</div>
            </td>
          </tr>
        </table>
        <table class="table7">
          <tr class="tr">
            <td width="177px">
              <span class="tdTit">任職公司：</span>
              <div class="con43">
                <span>{{editedItem.jointGuarantor.companyName}}</span>
              </div>
            </td>
            <td width="177px">
              <span class="tdTit">公司統編：</span>
              <div class="con44"></div>
            </td>
            <td width="195px">
              <span class="tdTit">職稱：</span>
              <div class="con45">
                <span>{{editedItem.jointGuarantor.title}}</span>
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">年資：</span>
              <span class="con46">
                {{editedItem.jointGuarantor.workYear}}
                <span>年</span>
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <span class="tdTit">公司地址：</span>
              <div class="con47">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div class="con48">
                <span>{{editedItem.jointGuarantor.companyAddress}}</span>
              </div>
            </td>
            <td>
              <span class="tdTit">公司電話：</span>
              <div class="con49">{{editedItem.jointGuarantor.companyPhone}}</div>
              <span class="tdTit tdTit49">分機：</span>
              <div class="con50">{{editedItem.jointGuarantor.companySubPhone}}</div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">月收入：NT</span>
              <span class="con51">
                {{editedItem.jointGuarantor.salary}}
                <span>萬元</span>
              </span>
            </td>
          </tr>
        </table>
        <table class="table8">
          <tr class="tr">
            <td width="450px">
              <span class="tdTit">戶籍地址：</span>
              <div class="con52">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div class="con53">
                <span>{{editedItem.jointGuarantor.home.residenceAddress}}</span>
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">戶籍電話：</span>
              <div class="con54">{{editedItem.jointGuarantor.phone}}</div>
              <div class="con55">
                <div class="checkDiv">
                  <span class="checkbox checkbox18">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                      <img v-if="editedItem.jointGuarantor.home.liveLevel[0].value" :src="checkedImage"  />
                    </label>
                  </span>
                  自有
                </div>
                <div class="checkDiv">
                  <span class="checkbox checkbox19">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                       <img v-if="editedItem.jointGuarantor.home.liveLevel[1].value" :src="checkedImage"  />
                    </label>
                  </span>
                  家人
                  <span class="s1"></span>
                </div>
                <br />
                <div class="checkDiv">
                  <span class="checkbox checkbox20">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                       <img v-if="editedItem.jointGuarantor.home.liveLevel[3].value" :src="checkedImage"  />
                    </label>
                  </span>
                  租賃，居住
                  <span class="s3">年</span>
                  <span class="s2">{{editedItem.jointGuarantor.home.liveYear}}</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="tdTit">通訊地址：</span>
              <div class="con56">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div class="con57">
                <span>{{editedItem.jointGuarantor.home.homeAddress1}}</span>
              </div>
              <div class="con58">
                <div class="checkDiv">
                  <span class="checkbox checkbox21">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                      <img v-if="editedItem.jointGuarantor.home.homeType1[0].value" :src="checkedImage"  />
                    </label>
                  </span>
                  同戶籍
                </div>
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">通訊電話：</span>
              <div class="con59">{{editedItem.jointGuarantor.homePhone}}</div>
              <div class="con60">
                <div class="checkDiv">
                  <span class="checkbox checkbox22">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                       <img v-if="editedItem.jointGuarantor.home.liveLevel2[0].value" :src="checkedImage"  />
                    </label>
                  </span>
                  自有
                </div>
                <div class="checkDiv">
                  <span class="checkbox checkbox23">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                       <img v-if="editedItem.jointGuarantor.home.liveLevel2[1].value" :src="checkedImage"  />
                    </label>
                  </span>
                  家人
                  <span class="s1"></span>
                </div>
                <br />
                <div class="checkDiv">
                  <span class="checkbox checkbox24">
                    <input type="checkbox" disabled checked id="checkbox-1" />
                    <label for="checkbox-1">
                       <img v-if="editedItem.jointGuarantor.home.liveLevel2[3].value" :src="checkedImage"  />
                    </label>
                  </span>
                  租賃，居住
                  <span class="s3">年</span>
                  <span class="s2">{{editedItem.jointGuarantor.home.liveYear2}}</span>
                </div>
              </div>
            </td>
          </tr>
        </table>
        <div class="clear"></div>
      </div>
      <!--area3-->

      <div class="area5">
        <div
          class="title"
        >特&nbsp;&nbsp;&nbsp;&nbsp;約&nbsp;&nbsp;&nbsp;&nbsp;商&nbsp;&nbsp;&nbsp;&nbsp;填&nbsp;&nbsp;&nbsp;&nbsp;寫</div>
        <table class="table9">
          <tr class="trB">
            <td rowspan="2" class="title2" width="18px">
              申
              <br />辦
              <br />產
              <br />品
            </td>
            <td width="177px">
              <span class="tdTit">廠牌：</span>
              <div class="con61">{{editedItem.laonhfcInfo.vendor}}</div>
            </td>
            <td width="195px">
              <span class="tdTit">車名：</span>
              <div class="con62">{{editedItem.laonhfcInfo.name}}</div>
            </td>
            <td width="158px">
              <span class="tdTit">出廠年月：</span>
              <div class="con63">
                <span class="y">
                  {{editedItem.laonhfcInfo.publicYear}}
                  <span>年</span>
                </span>
                <span class="m">
                  {{editedItem.laonhfcInfo.publicMonth}}
                  <span>月</span>
                </span>
              </div>
            </td>
            <td width="98px">
              <span class="tdTit">車號：</span>
              <div class="con64">{{editedItem.laonhfcInfo.carId}}</div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">CC：</span>
              <div class="con65">{{editedItem.laonhfcInfo.cc}}</div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="tdTit">分期金額：</span>
              <div class="con66">{{editedItem.vendor.totalPrice === 0 ? '' : editedItem.vendor.totalPrice}}</div>
              <!-- <div class="con66">{{editedItem.vendor.totalCreditPrice === 0 ? '' : editedItem.vendor.totalCreditPrice}}</div> -->
            </td>
            <td>
              <span class="tdTit">分期期數：</span>
              <div class="con67">{{editedItem.vendor.installmentsNumber}}</div>
            </td>
            <td>
              <span class="tdTit">期付款：</span>
              <div class="con68">{{editedItem.vendor.creditPriceMonth === 0 ? '' : editedItem.vendor.creditPriceMonth}}</div>
            </td>
            <td class="tdEnd">
              <span class="tdTit">利率：</span>
              <span class="con69">

                <span>％</span>
              </span>
            </td>
          </tr>
        </table>
        <table class="table10">
          <tr class="trB">
            <td width="198px">
              <span class="tdTit">特約商名稱：</span>
              <div class="con70">
                <span></span>
              </div>
            </td>
            <td width="195px">
              <span class="tdTit">特約商統編：</span>
              <div class="con71"></div>
            </td>
            <td rowspan="2" class="tdEnd stamp">
              <span class="tdTit">公司章或發票章：</span>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="signBox">
              <span class="tdTit">承辦人簽名：</span>
            </td>
          </tr>
        </table>
      </div>
      <!--area4-->
    </div>
    <!--page1-->
  </div>
  <!--wrapper-->
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { sortApplicationItem } from '@/pages/utils/tool';

export default {
  name: "loanhfcTemplateView",
  props: {
    item: Object
  },
  data() {
      return {
        checkedImage: require('../../assets/images/checked.png'),
        createDate: '',
        itemInfo: null,
      }
    },
  computed: {
    ...mapGetters(['getUserInfo']),
    editedItem() {
      this.itemInfo = sortApplicationItem(this.item);
      console.log(`this.itemInfo === ${JSON.stringify(this.itemInfo)}`);
      return this.itemInfo;
    },
  },
  methods: {
      
  }
};
</script>

<style scoped src="../../assets/css/loanhfc_template.css">
</style>



// WEBPACK FOOTER //
// src/pages/web/loanhfcTemplateView.vue